import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Template from '../../template/template';
import useAppContext from '../../../context/useAppContext';

import StatusTransitionsRouter from './statusTransitionsRouter';
import AuthRouteModeration from '../../../utils/authRouteModeration';

import ModerationFlows from '../../../pages/moderation';
import ModerationAttendees from '../../../pages/moderation/attendees/Attendees';
import ModerationProfile from '../../../pages/moderation/attendees/profile';
import OperatorsList from '../../../pages/moderation/operators';
import OperatorDetails from '../../../pages/moderation/operators/OperatorDetails';
import FilesRouter from './filesRouter';
import FlowDetails from '../../../pages/moderation/flow/flowDetails';

const FlowRouter = ({ path }) => {
    const [{ organization }] = useAppContext();

    return (
        <Switch>
            <Route
                exact
                path={`${path}/`}
                render={() => (
                    <Template organization={organization}>
                        <ModerationFlows organization={organization} />
                    </Template>
                )}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/new`}
                render={() => (
                    <Template organization={organization}>
                        <FlowDetails organizationId={organization.id} />
                    </Template>
                )}
            />

            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN', 'PyvarCapacity.MODERATION_ADMIN', 'PyvarCapacity.MODERATION_SETTINGS']}
                path={`${path}/:flowId/settings`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <FlowDetails organizationId={organization.id} flowId={match.params.flowId} />
                    </Template>
                )}
            />
            <Route
                exact
                path={`${path}/:flowId/moderation_attendees`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <ModerationAttendees organization={organization} flowId={match.params.flowId} />
                    </Template>
                )}
            />
            <Route
                exact
                path={`${path}/:flowId/moderation_attendees/:attendeeId`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <ModerationProfile organization={organization} flowId={match.params.flowId} attendeeId={match.params.attendeeId} />
                    </Template>
                )}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/:flowId/moderation_users`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <OperatorsList organizationId={organization.id} flowId={match.params.flowId} />
                    </Template>
                )}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/:flowId/moderation_users/new`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <OperatorDetails organizationId={organization.id} flowId={match.params.flowId} />
                    </Template>
                )}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/:flowId/moderation_users/:operatorId`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <OperatorDetails organizationId={organization.id} operatorId={match.params.operatorId} flowId={match.params.flowId} />
                    </Template>
                )}
            />
            <Route
                allow={['PyvarCapacity.MODERATION_EXPORTS']}
                path={`${path}/:flowId/files`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <FilesRouter organization={organization} path={`${path}/:flowId/files`} url={match.url} />
                    </Template>
                )}
            />
            <AuthRouteModeration
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/:flowId/statuses_transitions`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <StatusTransitionsRouter organization={organization} path={`${path}/:flowId/statuses_transitions`} url={match.url} />
                    </Template>
                )}
            />
        </Switch>
    );
};

export default FlowRouter;
